import Modal from '@mui/material/Modal';
import Box from '@mui/material/Box';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import WarningIcon from '@mui/icons-material/Warning';
import AccessTimeIcon from '@mui/icons-material/AccessTime';

import Button from '../../common/Button';
import { translate } from '../../../helper';
import { capitalize } from '../../../utils/CommonFunction';

const style = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: '90%',
    bgcolor: 'background.paper',
    p: 4,
    borderRadius: "8px"
};

export default function AddDealerModal(props) {
    const {
        open,
        onClose,
        mode,
        data,
        type,
        context,
        handleSubmit
    } = props

    const isSuccess = mode === 'success';
    const isQueued = mode === 'queued';
    const isWarning = mode === 'Warning';
    const isError = mode === 'error';

    const renderIcon = () => {
        if (isSuccess) {
            return <CheckCircleIcon sx={{ fontSize: 60, color: '#FBB516' }} />;
        }
        if (isQueued) {
            return <AccessTimeIcon sx={{ fontSize: 60, color: '#F59E0B' }} />;
        }
        return <WarningIcon sx={{ fontSize: isWarning ? 100 : 60, color: '#FF0000' }} />;
    };

    const title = () => {
        if (isWarning) return translate('deleteOrderConfirmation');
        if (isSuccess) return translate('congratulations');
        if (isQueued) return translate('orderQueuedTitle');
        if (type === 'card') return translate('paymentFailed');
        return translate('dealerUnavailable');
    };

    const description = () => {
        if (isWarning) return `${translate('confirmation')}?`;
        if (isSuccess) return translate('orderPlacedConfirmation');
        if (isQueued) return translate('orderQueuedDescription');
        if (type === 'card') {
            return context?.length > 0
                ? context
                : translate('unableToProcessPayment');
        }
        return translate('selectContactDealer');
    };

    return (
        <Modal
            open={open}
            onClose={onClose}
            aria-labelledby="modal-modal-title"
            aria-describedby="modal-modal-description"
        >
            <Box sx={style}>
                <div
                    style={{
                        width: "100%",
                        textAlign: "center"
                    }}
                >
                    {renderIcon()}
                </div>
                <h2
                    style={{
                        textAlign: 'center',
                        fontSize: isSuccess ? '24px' : '20px',
                        fontWeight: 600,
                        lineHeight: '30px',
                        color: isSuccess ? '#FBB516' : isQueued ? '#F59E0B' : '#FF2020'
                    }}
                >
                    {title()}
                </h2>
                <div
                    style={{
                        textAlign: 'center',
                        fontSize: '14px',
                        fontWeight: 400,
                        lineHeight: '21px',
                    }}
                >
                    {description()}
                </div>
                {isSuccess && <table
                    style={{
                        width: "100%",
                        marginTop: "20px"
                    }}
                >
                    <tr>
                        <td style={{ padding: "20px 0" }}>{translate('jobPendingNotice')}</td>
                        <td style={{ padding: "20px 0" }}>{data.po}</td>
                    </tr>
                    <tr>
                        <td style={{ padding: "20px 0" }}>{translate('status')}: {capitalize(data.status)}</td>
                        <td style={{ padding: "20px 0" }}>{translate('')}</td>
                    </tr>
                    {
                        data.created && <tr>
                            <td style={{ padding: "20px 0" }}>{translate('dateCreated')}</td>
                            <td style={{ padding: "20px 0" }}>{data.created}</td>
                        </tr>
                    }
                    {
                        data.dealer && <tr>
                            <td style={{ padding: "20px 0" }}>{translate('dealerName')}</td>
                            <td style={{ padding: "20px 0" }}>{data.dealer}</td>
                        </tr>
                    }
                    {
                        data.amount && <tr>
                            <td style={{ padding: "20px 0" }}>{translate('amount')}</td>
                            <td style={{ padding: "20px 0" }}>USD {data.amount}</td>
                        </tr>
                    }
                    {
                        data.paid && <tr>
                            <td style={{ padding: "20px 0" }}>{translate('paidOn')}</td>
                            <td style={{ padding: "20px 0" }}>{data.paid}</td>
                        </tr>
                    }
                </table>}
                {
                    isWarning ? <div
                        style={{
                            marginLeft: "-32px",
                            height: "fit-content",
                            borderTop: "1px solid #E5E7EB",
                            width: "calc(100% + 64px)",
                            display: "flex",
                            justifyContent: "space-between",
                            marginBottom: "-32px",

                        }}
                    >
                        <div
                            style={{
                                width: "50%",
                                fontWeight: "600",
                                display: "flex",
                                justifyContent: "center",
                                alignItems: "center",
                                borderRight: "1px solid #E5E7EB",
                                padding: "20px 0",
                            }}
                            onClick={onClose}
                        >
                            {translate('no')}
                        </div>
                        <div
                            style={{
                                width: "50%",
                                color: "#ff0000",
                                fontWeight: "600",
                                display: "flex",
                                justifyContent: "center",
                                alignItems: "center",
                                padding: "20px 0",
                            }}
                            onClick={handleSubmit}
                        >
                            {translate('yes')}
                        </div>
                    </div> :
                        <Button
                            onClick={() => {
                                isError ? onClose('err') : onClose()
                            }}
                            style={{ marginTop: "2rem" }}>{type === 'card' && !isSuccess ? translate('tryAgain') : translate('ok')}</Button>

                }
            </Box>
        </Modal>
    )
}